import { toastBlueprint } from "@made-people/blueprint-toast/blueprint";

toastBlueprint.override({
  slots: {
    wrapper:
      "flex rounded-lg shadow-lg border-b-2 border-black/10 w-full md:w-[356px] items-center p-4",
    container: "flex flex-1 items-center w-full",
    content: "w-full flex flex-col gap-2",
    title: "text-heading-xs flex gap-3",
    icon: "size-4 mt-px",
    description: "text-body-sm",
  },
  variants: {
    type: {
      error: {
        wrapper: "bg-red-200",
        title: "text-red-950",
        description: "text-red-950",
        icon: "fill-red-950",
      },
      success: {
        wrapper: "bg-green-200",
        title: "text-green-950",
        description: "text-green-950",
        icon: "fill-green-950",
      },
      info: {
        wrapper: "bg-white",
      },
      warning: {
        wrapper: "bg-yellow-200",
      },
    },
  },
});
